import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Value } from '@philips-internal/oswald-ui-core';

import { Endpoint } from '../../../constants/endpoints';

export interface SearchAllInfusionProps {
  currentBarcode?: string;
  prescriptionNumber: number;
  solutionSequenceNumber: number;
  stepSolutionNumber: number;
}

export interface ReadOneInfusionCardProps {
  barcode: string;
  doseQuantity?: number;
  prescriptionNumber: number;
  scheduleSequence: number;
  solutionSequenceNumber: number;
  stepSolutionNumber: number;
}

export default class AdminInfusionScheduleReadingCard {

  public static searchAllInfusionsPendding(data: SearchAllInfusionProps): Promise<Record<string, Value>[]> {
    const { prescriptionNumber, solutionSequenceNumber, stepSolutionNumber } = data;

    const params = {
      prescriptionNumber,
      solutionSequenceNumber,
      stepSolutionNumber
    }

    return HttpService.get(Endpoint.EMAR_FIND_INFUSION_BY_SCHEDULE, params)
      .then(response => {
        return response.body as Record<string, Value>[];
      });
  }

  public static readOneInfusionCard(data: ReadOneInfusionCardProps): Promise<void | Record<string, Value>> {
    const body = Object.assign({}, data) as unknown as Record<string, Value>;

    return HttpService.post(Endpoint.EMAR_READ_ONE_INFUSION_CARD, {},
      { body }
    ).then((res) => {
      return res.body as Record<string, Value>;
    });
  }
}
